import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {catchError, Observable, switchMap, throwError} from "rxjs";
import {AuthService} from "../../services/auth/auth.service";
import {inject} from "@angular/core";

export const AuthInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if(error.status === 401 && !request.url.includes("/refreshToken")) {
                return authService.refreshAccessToken().pipe(
                    switchMap(() => next(request)),
                    catchError(() => {
                        authService.logout();
                        return throwError(() => error);
                    })
                )
            } else {
                return throwError(() => error);
            }
        })
    );
}
